<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'TransferTypeList' }" class="nav-link">Typy przelewów</router-link></h2><div class="page-title__buttons"><router-link :to="{ name: 'TransferTypeCreate' }" class="btn btn-default"><span>Dodaj typ przelewu</span><svg-icon name="plus"/></router-link></div></page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>

			<div v-if="!loading">	
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
						<thead>
						<tr>
							<th>Nazwa</th>
							<th>Cena</th>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item in items">
							<td><router-link v-if="item" :to="{name: 'TransferTypeShow', params: { id: item['id'] }}">{{ item['name'] }}</router-link></td>
							<td><router-link v-if="item" :to="{name: 'TransferTypeShow', params: { id: item['id'] }}">{{ item['amount'] }} PLN</router-link></td>
							<td>
								<router-link :to="{name: 'TransferTypeUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
									<svg-icon name="edit"/>
								</router-link>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    computed: mapGetters({
      error: 'transfertype/list/error',
      items: 'transfertype/list/items',
      loading: 'transfertype/list/loading',
      view: 'transfertype/list/view'
    }),
    methods: mapActions({
      getPage: 'transfertype/list/getItems'
    }),
    created () {
      this.$store.dispatch('transfertype/list/getItems')
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?0f923e78